<template>
	<div>
		<div class="contacts--list__item">
			<label class="check">
				<input type="checkbox" />
				<div class="check-mark"></div>
			</label>
			<p>{{ country.name }}</p>
			<p class="info__address">{{ country.currency_code }}</p>
			<p class="info__address">{{ country.dial_code }}</p>
			<p>
				<router-link
					:to="{ name: 'country-details', params: { id: country.id } }"
					class="btn btn__primary"
					id="countryDetail"
				>
					View Details
				</router-link>
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CountryItem',
	props: {
		countryData: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
		return {
			country: this.countryData,
			itemData: '',
			mapStatus: ''
		};
	}
};
</script>

<style scoped>
.badge {
	font-weight: normal;
}
.contacts--list__item {
	display: grid;
	grid-template-columns: 100px 1fr 1fr 1fr 150px !important;
}
.info__primary {
	width: 100%;
	text-overflow: ellipsis;
	overflow: hidden;
	margin-right: 10px;
}
.info__email {
	text-transform: lowercase;
}
.contacts__info {
	overflow: hidden;
}
</style>
